const DEVICE_ID_STORAGE_KEY = 'connector-service-device-id-v1';

function toHex(buffer: ArrayBuffer): string {
  return Array.from(new Uint8Array(buffer))
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('');
}

function fallbackHash(input: string): string {
  let hash = 2166136261;
  for (let i = 0; i < input.length; i++) {
    hash ^= input.charCodeAt(i);
    hash = Math.imul(hash, 16777619);
  }
  return Math.abs(hash >>> 0).toString(16).padStart(8, '0');
}

function buildDeviceFingerprintSeed(): string {
  const nav = window.navigator;
  const screenInfo = window.screen;
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'unknown';

  const parts = [
    nav.userAgent || '',
    nav.platform || '',
    nav.language || '',
    String(nav.hardwareConcurrency || ''),
    String((nav as Navigator & { deviceMemory?: number }).deviceMemory || ''),
    String(screenInfo?.width || ''),
    String(screenInfo?.height || ''),
    String(screenInfo?.colorDepth || ''),
    timezone,
  ];

  return parts.join('|');
}

export async function getOrCreateDeviceId(): Promise<string> {
  const existing = localStorage.getItem(DEVICE_ID_STORAGE_KEY);
  if (existing) {
    return existing;
  }

  const seed = buildDeviceFingerprintSeed();
  let fingerprint = '';

  if (crypto?.subtle) {
    const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(seed));
    fingerprint = toHex(digest);
  } else {
    fingerprint = fallbackHash(seed);
  }

  const deviceId = `web-${fingerprint.slice(0, 48)}`;
  localStorage.setItem(DEVICE_ID_STORAGE_KEY, deviceId);
  return deviceId;
}
